import { RouteType } from "types/RouteType";
import dispatchRoute from "./Dispatch/dispatch.Route";
import dispatchDashboardRoute from "./Dashboard/dispatchDashboard.Route";
import loadListRoute from "./LoadList/loadList.Route";

const dispatchRoutesList: RouteType[] = [
    dispatchDashboardRoute, // Dispatch dashboard for ready-mix trucks
    dispatchRoute, // Main dispatch interface for truck scheduling
    loadListRoute, // Ready-mix truck load management
];

export default dispatchRoutesList;
